//*Libraries imports
import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useDispatch } from "react-redux";

//*Components imports
import { Toaster } from "@components/ui/sonner";

//*Hooks Imports

//*Store imports
import { checkAuth } from "./features/auth/authSlice";

//*Types imports
import type { AppDispatch } from "./app/store";

//*Routes imports
import { routes } from './app/routes';

const router = createBrowserRouter(routes);

function App() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      dispatch(checkAuth());
    }
  }, [dispatch]);

  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}

export default App;